
import * as Components from "./Shisoall"

export default function getCustomComponent () {
  return Components
}

export function getShopId () {
  return "shisoall"
}

